export default __webpack_public_path__ + "13b4d5c9367976bd1f908238a512ddfd.webp";